// Eventkonfiguration – fyll i / justera uppgifter här.
export const EVENT = {
  // Födelsedagsbarnets namn
  name: "Pierre",
  age: 40,

  // Datum & tid (ISO 8601, lokal tid). Används för nedräkningen.
  date: "2026-10-17T12:45:00",
  dateLabel: "17th–18th of October 2026",
  timeLabel: "Meeting time 12:45",

  // Plats
  venue: "Sandhamn",
  address: "Meet-up at Stavsnäs Vinterhamn – boat out to Sandhamn",
  // Valfri exakt kartlänk (annars söks platsen automatiskt)
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Stavsn%C3%A4s%20Vinterhamn",

  // Klädkoder
  dressCodeDinner: "Black Tie",
  dressCodeEvening: "Beach Chic",

  // Boende
  accommodationPrice: "SEK 2,900 per room including breakfast",
  accommodationCancel: "Free cancellation up to 5 days before arrival",
  accommodationNotes: [
    "Your room at Seglarhotellet is booked automatically when you RSVP",
    "No need to contact the hotel",
    "Payment on check-out",
  ],
  accommodationOptOut: "Prefer not to stay at Seglarhotellet? Just email us.",
  accommodationEmail: "pierre40@kinghippo.se",
  accommodationRef: "Pierre Garami",

  // Övrig praktisk info
  giftsNote: "No presents, please – your presence is the greatest gift I could ask for.",
  contactEmail: "pierre40@kinghippo.se",
  rsvpDeadline: "as soon as possible",

  // Personligt välkomstmeddelande (visas i Welcome-sektionen)
  intro: [
    "Turning 40 isn't just about celebrating another year. It's about celebrating the people who have shaped my life along the way.",
    "I feel incredibly fortunate to have each of you in my life. Through the years, you've shared unforgettable moments, supported me through challenges, and made the journey far more meaningful than I could have imagined.",
    "That's why I wanted to bring everyone together for one special weekend. My only wish is that we relax, enjoy great food and drinks, laugh a little louder than usual, and create a few more memories together.",
    "Thank you for being part of my life. I truly can't wait to celebrate with all of you on beautiful Sandhamn.",
  ],

  // Program / tidslinje
  schedule: [
    {
      time: "12:45",
      title: "Departure · Stavsnäs Vinterhamn",
      desc: "Please arrive at Stavsnäs Vinterhamn by 12:45. We'll depart together shortly afterwards for Sandhamn.",
      linkText: "Open in Google Maps",
      linkUrl: "https://maps.app.goo.gl/CCv9jdRzzaWu4cB6A?g_st=ic",
    },
    {
      time: "Afternoon",
      title: "Enjoy the island at your own pace",
      desc: "The spa, sauna and jetty are reserved exclusively for us – swim, unwind or simply take in the island.",
    },
    {
      time: "16:00",
      title: "Pre-dinner drinks",
      desc: "We gather for a glass together as the evening begins.",
    },
    {
      time: "17:00",
      title: "Dinner · Black Tie",
      desc: "A long, festive dinner with great food, good wine and a toast or two.",
    },
    {
      time: "Toastmasters",
      title: "The Johans",
      desc: "The Johans will guide you through the evening – speeches, surprises and everything in between.",
      images: ["/photos/toastmasters.jpg"],
      extraText: "Would you like to give a speech? Please email",
      extraEmail: "speech@kinghippo.se",
    },
    {
      time: "21:00",
      title: "A moment to recharge",
      desc: "Dinner draws to a close – time to change and gather energy before the night continues.",
    },
    {
      time: "21:30",
      title: "Garami Spa Club opens",
      sub: "Dress code: Beach Chic",
      desc: "Join us down by the spa for music, cocktails and dancing long into the late hours.",
      images: ["/photos/beachclub2.jpg"],
    },
  ],

  // Bakgrundsmusik (spelas när gästen trycker play)
  musicSrc: "/music.mp3",
  musicTitle: "Dallas – Theme Song",

  // Logotyp
  logo: "/photos/logo-dark.png",

  // Hero-bild (byt gärna till egen bild från Sandhamn/Seglarhotellet)
  heroImage: "/photos/hero.jpg",
};
